import { ProductMenuComponent } from './../../components/product-menu/product-menu.component';
import { AddAddressComponent } from './add-address/add-address.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { UpdateProductComponent } from '@app/modules/modals/update-product/update-product.component';
import { SharedModule } from '@app/modules/shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PipesModule } from '@app/pipes/pipes.module';
import { PersonalizeProductComponent } from '@app/modules/modals/personalize-product/personalize-product.component';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { PersonalizeMenuProductComponent } from '@app/modules/modals/personalize-menu-product/personalize-menu-product';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { TabsModule } from 'ngx-bootstrap';
import { OptionsSuppComponent } from './options-supp/options-supp.component';
import { TicketComponent } from '@app/components/ticket/ticket.component';

defineLocale('fr', frLocale); 
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        AccordionModule.forRoot(),
        TooltipModule.forRoot(),
        SharedModule,
        PipesModule,
        TabsModule.forRoot()
    ],
    declarations: [
        UpdateProductComponent,
        PersonalizeProductComponent,
        MenuModalComponent,
        PersonalizeMenuProductComponent,
        AddAddressComponent,
        ProductMenuComponent,
        OptionsSuppComponent,
        TicketComponent
    ],
    exports: [
        UpdateProductComponent,
        PersonalizeProductComponent,
        ProductMenuComponent,
        OptionsSuppComponent,
        TicketComponent
    ],
    entryComponents: [
        UpdateProductComponent,
        PersonalizeProductComponent,
        MenuModalComponent,
        PersonalizeMenuProductComponent,
        AddAddressComponent,
        OptionsSuppComponent,
        TicketComponent
    ]
})

export class ModalsModule {

}
